import React from 'react';
import { useCandidatesOverviewContext } from '../Contexts/CandidatesOverviewContext/CandidatesOverviewContext';
import UIStrings from '@/Utils/UIStrings';
import CandidatesPageHeader from '../../components/CandidatesPageHeader';

function CandidatesOverviewHeader(): React.JSX.Element {
    const { tabValue, assessmentName } = useCandidatesOverviewContext();

    return (
        <CandidatesPageHeader>
            <h2 className="text-secondary-foreground text-2xl leading-tight font-semibold tracking-tight">
                {UIStrings.CandidateTabsToPageTitle(tabValue)}
                <span className="font-normal">{` ${UIStrings.For} `}</span>
                {assessmentName}
            </h2>
        </CandidatesPageHeader>
    );
}

export default CandidatesOverviewHeader;
